<div class="bg-bg-base min-h-screen text-text-primary antialiased">
  <app-seeker-header></app-seeker-header>
  <app-seeker-tabs-navigation></app-seeker-tabs-navigation>
  <app-seeker-tabs-content></app-seeker-tabs-content>
</div>
